import React, { Fragment, PureComponent, useEffect, useMemo, useState } from 'react';
import {
  ControlsTypeIcon,
  CustomPreviewIcon,
  MediaFileHeaderItems,
  MediaFileListConfig,
} from '../contstants/constants';
import cn from 'classnames';
import { loadChatMedia } from '../../../../../chat/modules/load-messages';
import { connect } from 'react-redux';
import Svg from '../../../../../common/components/Svg';
import { openLightbox } from '../../../../../chat/modules/lightbox';
import { filenameFromUrl } from '../../../../../common/utils/text';

const MediaFileList = ({
  items,
  customIcon,
  direction = 'col',
  loading,
  onItemClick = () => {},
  onControlsClick = () => {},
  controls = [],
}) => {
  const isCol = direction === 'col';
  const isRow = direction === 'row';

  const getCustomIcon = type => customIcon || CustomPreviewIcon[String(type).toLowerCase()];

  const handleItemClick = el => {
    let newCheckedItemsId = [];
    onItemClick(el, newCheckedItemsId);
  };

  if (loading) {
    return <div className="mediaFilesList_loading">loading...</div>;
  }

  if (!(items && items.length)) {
    return <div className="mediaFilesList_empty">Nothing yet</div>;
  }

  return (
    <div className={cn('mediaFilesList', { row: isRow, col: isCol })}>
      {items.map(
        ({ url, filename, link, timestamp, url_original, id, type, class_name }, index) => (
          <div
            onClick={() =>
              handleItemClick({ url, url_original, id, filename, class_name, class_name })
            }
            className="mediaFilesList_item"
            key={timestamp + (filename || link)}
          >
            {Boolean(controls.length) && (
              <div className="mediaFilesList_controls">
                {controls.map(el => (
                  <div
                    onClick={() => {
                      onControlsClick(el, {
                        url,
                        url_original,
                        id,
                        filename,
                        class_name,
                        class_name,
                      });
                    }}
                    className="mediaFilesList_controls_item"
                    key={el}
                  >
                    <Svg icon={ControlsTypeIcon[el]} />
                  </div>
                ))}
              </div>
            )}
            {getCustomIcon(type) ? (
              <div className="mediaFilesList_item_image">
                <Svg icon={getCustomIcon(type)} />
              </div>
            ) : (
              <div className="mediaFilesList_item_image">
                <img src={url} />
              </div>
            )}

            {filename && (
              <div className="mediaFilesList_item_name" title={filename}>
                {filename}
              </div>
            )}
            {link && (
              <div className="mediaFilesList_item_name">
                <a target="_blank" href={link}>
                  {filenameFromUrl(link) || link}
                </a>
              </div>
            )}
          </div>
        ),
      )}
    </div>
  );
};

const MediFilesBlock = ({ messages, mediaFilesList, projectId, loadChatMedia, openLightbox }) => {
  const [activeTab, setActiveTab] = useState(MediaFileHeaderItems[0].type);
  const [loading, setIsLoading] = useState(false);

  useEffect(
    () => {
      setIsLoading(true);
      loadChatMedia(projectId, activeTab).finally(() => {
        setIsLoading(false);
      });
    },
    [activeTab],
  );

  const handleItemClick = ({ url, url_original, id, filename, class_name }, items) => {
    if (MediaFileListConfig[activeTab].preview) {
      openLightbox({ url, url_original, id, filename, class_name });
    }
  };

  const handleControlsClick = (type, { url_original, filename }) => {
    if (type === 'download') downloadFile({ url_original, filename });
  };

  const downloadFile = ({ url_original, filename }) => {
    const a = document.createElement('a');
    a.href = url_original;
    a.target = '_blank';
    a.download = filename;
    a.click();
  };

  const handleTabChange = type => {
    if (loading) return;
    setActiveTab(type);
  };

  return (
    <div className="mediaFilesBlock">
      <div className="mediaFilesBlock_header">
        {MediaFileHeaderItems.map(({ type, label }) => (
          <div
            onClick={() => handleTabChange(type)}
            className={cn('mediaFilesBlock_header_item', {
              '-active': activeTab === type,
            })}
            key={type}
          >
            {label}
          </div>
        ))}
      </div>
      <div className="mediaFilesBlock_body">
        <MediaFileList
          loading={loading}
          items={mediaFilesList}
          onItemClick={handleItemClick}
          onControlsClick={handleControlsClick}
          controls={MediaFileListConfig[activeTab].controls}
          direction={MediaFileListConfig[activeTab].direction}
          customIcon={MediaFileListConfig[activeTab].iconClass}
        />
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  loadChatMedia,
  openLightbox,
};

const mapStateToProps = state => {
  return {
    mediaFilesList: state.chat.mediaFilesList,
    projectId: state.chat.projectId,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MediFilesBlock);



// WEBPACK FOOTER //
// ./app/javascript/customer_chat/components/chat/shared/components/MediFilesBlock.js